import { render, staticRenderFns } from "./btn-chevron-right.vue?vue&type=template&id=460b3e0f&"
import script from "./btn-chevron-right.vue?vue&type=script&lang=js&"
export * from "./btn-chevron-right.vue?vue&type=script&lang=js&"
import style0 from "./btn-chevron-right.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports